import * as MyDataBase from "../utils/Firebase";
import firebase from "../utils/Firebase";
import { store } from '../Redux/Store/store';
import { setRestaurantName, setCategories, setItemsByCategories, setRestaurantInfo, setPostsFeed, setRestaurantNotFound, setCategoriesGraph, setDishesByCategoryGraphLookup, setDishesLookup } 
        from '../Redux/Actions/Actions';
import { makeCategoriesGraph } from "../utils/Categories Graph/CategoriesGraphBuilder";
import { makeDishesGraphForCategory } from "../utils/Dishes Graph/CategoryDishesGraphBuilder";


export let categories = [];
export let menuItemsByCategory = [];
export let postsFeed = [];
export let restaurantName = "";

export const authAndLoadRestaurantData = ( restaurantID ) => {

    firebase.auth().signInAnonymously();

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        importCategoriesData( restaurantID );
        importMenuItems( restaurantID );
        importFeeds( restaurantID );
        importRestaurantName( restaurantID );
      }
    });

}

const importCategoriesData = ( restaurantID ) => {
    MyDataBase.MENU_CATEGORIES.child( restaurantID ).on(
        "value",
        (snapshot) => {
          
          if( snapshot.exists() ) {

            categories = Object.values(snapshot.val().categories)
                            .filter((item) => item.visible)
                            .sort((a, b) => (a.pos < b.pos ? -1 : a.pos === b.pos ? 0 : 1));

            let categoriesGraph = makeCategoriesGraph(categories)

            store.dispatch( setCategories( categories ) );
            store.dispatch( setCategoriesGraph( categoriesGraph ) )

          } else
              store.dispatch( setRestaurantNotFound( true ) );
        }
      );
}

const importMenuItems = ( restaurantID ) => {
    MyDataBase.RESTAURANT_MENU.child( restaurantID ).on(
        "value",
        (snapshot) => {

          if( snapshot.exists() ) {

            // Make CategoryKey -> [Dish] lookup table
            let vociDelMenu = Object.values(snapshot.val().items)
                                .filter(dish => dish.available);

            for (let i = 0; i < categories.length; i++) {
              menuItemsByCategory[
                categories[i].categoryKey
              ] = vociDelMenu.filter((item) => {
                return item.categoryKey === categories[i].categoryKey;
              });
            }

            // Make CategoryKey -> DirectedGraph<Dish> lookup table
            let graphsLookup = {  }
            Object.keys(menuItemsByCategory).forEach( categoryKey => {
                graphsLookup[categoryKey] = makeDishesGraphForCategory(menuItemsByCategory[categoryKey])

                if (graphsLookup[categoryKey].edgeSet().length <= 0 ) {
                  delete graphsLookup[categoryKey]
                }
            })

            let dishesLookupTables = {}

            vociDelMenu.forEach(dish => {
              if (!dishesLookupTables[dish.categoryKey]) {
                dishesLookupTables[dish.categoryKey] = {}
              }

              dishesLookupTables[dish.categoryKey][dish.itemKey] = dish
            })
            
            
            store.dispatch( setItemsByCategories(menuItemsByCategory) );
            store.dispatch( setDishesByCategoryGraphLookup(graphsLookup) )
            store.dispatch( setDishesLookup(dishesLookupTables) ) 
             
          } else
            store.dispatch( setRestaurantNotFound( true ) );
        }
      );
} 

const importFeeds = ( restaurantID ) => {
    MyDataBase.RESTAURANT_FEEDS.child(
        restaurantID + "/posts"
      ).on("value", (snapshot) => {

        if( snapshot.exists() ) {

          postsFeed = Object.values(snapshot.val()).reverse();
          store.dispatch( setPostsFeed( postsFeed ) );

        } else
            store.dispatch( setRestaurantNotFound( true ) );

      });
}

const importRestaurantName = ( restaurantID ) => {
    MyDataBase.RESTAURANT_INFO.child(restaurantID).on(
        "value",
        (snapshot) => { 

            if( snapshot.exists() ) {
              restaurantName = snapshot.val().name;
            
              store.dispatch( setRestaurantInfo( snapshot.val() ) );
              store.dispatch( setRestaurantName( restaurantName ) );

            } else
                store.dispatch( setRestaurantNotFound( true ) );
        }
      );
}